// src/services/companiasTenant.js
// Utilidades de compatibilidad para resolver compañías por Cuerpo.
// Huasco mantiene sus slugs/logos históricos mientras migramos a campos dinámicos.

export const HUASCO_LEGACY = {
  1: { slug: "kf83mx", logo: "/logos/logo-compania1.png" },
  2: { slug: "zl29qp", logo: "/logos/logo-compania2.png" },
  3: { slug: "rd77lt", logo: "/logos/logo-compania3.png" },
  4: { slug: "vb52cz", logo: "/logos/logo-compania4.png" },
  5: { slug: "wn64dy", logo: "/logos/logo-compania5.png" },
};

export function numeroOrdenCompania(compania) {
  const n = Number(compania?.orden);
  return Number.isFinite(n) ? n : 9999;
}

export function slugCompania(compania, cuerpoId) {
  const explicito = String(
    compania?.slug || compania?.codigo || compania?.slug_web || ""
  ).trim();

  if (explicito) return explicito.toLowerCase();

  if (String(cuerpoId || "").toLowerCase() === "huasco") {
    const legacy = HUASCO_LEGACY[numeroOrdenCompania(compania)];
    if (legacy) return legacy.slug;
  }

  // Para nuevos Cuerpos exigiremos slug en Firestore.
  // No usamos el nombre ni el ID automático como URL para evitar rutas inestables.
  return "";
}

export function logoCompania(compania, cuerpoId) {
  const explicito = String(
    compania?.logoURL ||
      compania?.logo_url ||
      compania?.logoUrl ||
      compania?.logo ||
      ""
  ).trim();

  if (explicito) return explicito;

  if (String(cuerpoId || "").toLowerCase() === "huasco") {
    const legacy = HUASCO_LEGACY[numeroOrdenCompania(compania)];
    if (legacy) return legacy.logo;
  }

  return "";
}

export function companiaActiva(compania) {
  return compania?.activo !== false;
}

export function prepararCompania(docSnap, cuerpoId) {
  const data = docSnap.data ? docSnap.data() : docSnap;
  return {
    id: docSnap.id || data?.id || "",
    ...data,
    slugResuelto: slugCompania(data, cuerpoId),
    logoResuelto: logoCompania(data, cuerpoId),
    ordenNumero: numeroOrdenCompania(data),
  };
}

export function ordenarCompanias(a, b) {
  const oa = numeroOrdenCompania(a);
  const ob = numeroOrdenCompania(b);
  if (oa !== ob) return oa - ob;
  return String(a?.nombre || "").localeCompare(String(b?.nombre || ""), "es");
}
